<template>
  <div class="notarizaBox">
    <div class="notarizaSearch">
      <span class="serach_title">申请时间：</span>
      <el-date-picker
        @change="searchChange"
        class="dataPickerCustom"
        v-model="searchData.signStartTimeBegin"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="选择时间"
        :picker-options="signDeadlineDateOption"
      ></el-date-picker>
      <span>&nbsp;-&nbsp;&nbsp;&nbsp;</span>
      <el-date-picker
        @change="searchChange"
        class="dataPickerCustom"
        value-format="yyyy-MM-dd"
        v-model="searchData.signStartTimeEnd"
        type="date"
        placeholder="选择时间"
        :picker-options="signDeadlineDateOption"
      ></el-date-picker>
      <span class="serach_title">公证状态：</span>
       <el-select v-model="searchData.notarizaStatus" placeholder="请选择公证状态">
            <el-option :label="item.label" :value="item.value" v-for="(item,index) in options" :key="index"></el-option>
        </el-select>
         <!-- <span class="serach_title">所属机构：</span>
       <el-select v-model="searchData.organization" placeholder="请选择机构" class="organization">
            <el-option :label="item.label" :value="item.value" v-for="(item,index) in organizationList" :key="index"></el-option>
        </el-select> -->
         <span class="serach_title">关键字：</span>
      <el-input class="search_input" v-model="notarizaName" placeholder="请输入公证编码/公证案件编号/申请人"></el-input>
      <span class="search" @click="searchFn">搜索</span>
    </div>
    <el-table
      border
      :data="tableData"
    >
      <template slot="empty">
        <img class="data-pic" src="../../../../assets/images/H5/null.png" alt>
        <br>暂无数据
      </template>
      <el-table-column prop="name" label="公证名称" width="140"></el-table-column>
      <el-table-column prop="code" label="公证编码" width="140"></el-table-column>
      <el-table-column prop="office" label="公证处" width="170"></el-table-column>
        <el-table-column label="当前状态" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status==0">审核拒绝</span>
          <span v-if="scope.row.status==1">等待提交</span>
          <span v-if="scope.row.status==2">等待审核</span>
          <span v-if="scope.row.status==3">等待付费</span>
          <span v-if="scope.row.status==4">等待制证</span>
          <span v-if="scope.row.status==5">已公证</span>
        </template>
      </el-table-column>
      <el-table-column prop="receiptor" label="申请人" width="100"></el-table-column>
        <el-table-column prop="createTime" label="申请时间" width="150"></el-table-column>
      <el-table-column prop="receiptor" label="类型" width="100"></el-table-column>
      <el-table-column label="公证进度" width="100">
        <template slot-scope="scope">
          <span @click="detailFn(scope.row.id)">查看</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
           <span
            type="text"
            size="small"
            v-if="scope.row.status>=3 && scope.row.status<4"
            @click="goDe(scope.row.id)"
          >公证详情</span>
          <span
            type="text"
            size="small"
            v-if="scope.row.status>=3 && scope.row.status<4"
            @click="goPay(scope.row.id)"
          >证据详情</span>
          <!-- <el-button type="text" size="small" v-if="scope.row.status!=3" style="color: rgb(200, 200, 200);">去支付</el-button> -->
          <span
            type="text"
            size="small"
            v-if="scope.row.status<=3 && scope.row.status!=0"
            @click="cancelNotarizationFn(scope.row.id)"
          >撤销公证</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="showPagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <Dialog
      :visible="successBox"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'400px'"
      class="hintMessageBox"
    >
      <div slot="dialog">
        <div class="hintMessCon">
          <p>是否取消公证</p>
          <p>
            <span @click="cancelFn">取消</span>
            <span @click="trueFn">确定</span>
          </p>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import storageUtil from "@lib/storageUtil.js";
import Util from "@lib/util.js";
import Dialog from "@common/Dialog.vue";
import {mapState} from "vuex"
export default {
  data() {
    return {
      type: 1,
      successBox: false,
      showPagination: false,
      currentPage: 1, //默认第一页
      total: 80, //总条数
      pageSizes: [10, 20, 50, 100, 200], //每页展示多少条
      pageSize: 10, //默认第一页展示10条
      tableData: [],
      notarizaName: "", //公证名称
      notarizaCode: "", //公正码
      notarizaData: "", //公证处
      id: "",
       searchData: {
        signStartTimeBegin: "",
        signStartTimeEnd: "",
        contractName: "",
        dataRange: "",
        notarizaStatus:"",
        organization:""
      },
      signDeadlineDateOption: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      organizationList: [
        {
          value: "2",
          label: "等待审核"
        },
        {
          value: "3",
          label: "等待付费"
        },
        {
          value: "4",
          label: "等待制证"
        },
        {
          value: "5",
          label: "已公证"
        }
      ],
      options: [
        {
          value: "2",
          label: "等待审核"
        },
        {
          value: "3",
          label: "等待付费"
        },
        {
          value: "4",
          label: "等待制证"
        },
        {
          value: "5",
          label: "已公证"
        }
      ],
      status: "" //当前状态
    };
  },
  methods: {
    ormatDat(secs) {
      //123456789 --> 年-月-日 时：分：秒
      var t = new Date(secs);
      var year = t.getFullYear();
      var month = t.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var date = t.getDate();
      if (date < 10) {
        date = "0" + date;
      }
      var hour = t.getHours();
      if (hour < 10) {
        hour = "0" + hour;
      }
      var minute = t.getMinutes();
      if (minute < 10) {
        minute = "0" + minute;
      }
      var second = t.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      return (
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
    searchChange() {
      if (
        this.searchData.signStartTimeBegin &&
        this.searchData.signStartTimeEnd
      ) {
        // console.log(this.searchData.signStartTimeBegin,this.searchData.signStartTimeEnd,Util);
        if (
          !Util.compareTime(
            this.searchData.signStartTimeBegin,
            this.searchData.signStartTimeEnd
          )
        ) {
          this.$message.error("开始时间不能大于结束时间");
          return;
        }
      }
      !this.searchData.signStartTimeBegin &&
        (this.searchData.signStartTimeBegin = "");
      !this.searchData.signStartTimeEnd &&
        (this.searchData.signStartTimeEnd = "");
      if (this.listFlag == storageUtil.getSession("signHomeCurrentListFlag")) {
        let temp = storageUtil.getSession(this.listFlag);
        if (temp) {
          temp = Object.assign(temp, this.searchData);
        }
        storageUtil.setSession(this.listFlag, this.searchData);
        this.$emit("searchChange", this.searchData);
      }
    },
    evidenceFn() {
      this.$router.push({
        path: "serviceHome/evidence"
      });
    },
    detailFn(id) {
      var params = {
        notaryServiceId: id,
        type: this.type
      };
      BaseApi.createRpcToken("/Judiciary/getNotarizationInfo", params,"GET")
        .then(
          data => {
            sessionStorage.setItem("procedure", JSON.stringify(data.datas));
            this.$router.push({
              path: "/serviceHome/writeProcedure",
              query: {
                id: id,
                fromType:1
              }
            });
          },
          data => {
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    closeDialog(data) {
      this.successBox = data;
    },
    cancelFn() {
      this.successBox = false;
    },
    goPay(num) {
      var params = {
        notaryServiceId: num
      };
      BaseApi.createRpcToken("/Judiciary/getNotarizationInfo", params,"GET")
        .then(
          data => {
            sessionStorage.setItem("procedure", JSON.stringify(data.datas));
            this.$router.push({
              path: "serviceHome/evidence/procedure",
              query: {
                id: num
              }
            });
          },
          data => {
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    cancelNotarizationFn(id) {
      this.successBox = true;
      this.id = id;
    },
    trueFn() {
      var params = {
        id: this.id
      };
      BaseApi.createRpcToken(
        "/Judiciary/cancelNotarization",
        params,
        "post"
      ).then(data => {
        this.successBox = false;
        this.init();
      });
    },
    init() {
      var params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      // BaseApi.createRpcToken("/Judiciary/getNotarizationList", params,"GET")
      //   .then(
      //     data => {
      //       if (data.datas != null) {
      //         this.tableData = data.datas.list;
      //         for (var i = 0; i < data.datas.list.length; i++) {
      //           data.datas.list[i].createTime = this.ormatDat(
      //             data.datas.list[i].createTime
      //           );
      //         }
      //         this.total = data.datas.totalRow;
      //         if (data.datas.totalRow > 10) {
      //           this.showPagination = true;
      //         } else {
      //           this.showPagination = false;
      //         }
      //       }
      //     },
      //     data => {
      //     }
      //   )
      //   .catch(function(e) {
      //     errorLog(e);
      //   });
    },
    searchFn() {
      this.init();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.init();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.currentPage = val;
      this.init();
    }
  },
  created() {
    this.init();
    this.type = JSON.parse(sessionStorage.getItem("userInfo")).realNameType;
  },
  components: {
    Dialog
  },
  computed:{
    ...mapState(['currentInfo']),
  },
   watch:{
    "currentInfo"(data){
       this.init()
    }
  }
};
</script>
<style lang="scss">
.el-table__body, .el-table__footer, .el-table__header {
    table-layout: auto !important;
    border-collapse: separate;
}
.notarizaBox {
  height: 100%;
  width: 100%;
  .el-table__cell{
    padding: 5px 0px!important;
  }
  .notarizaSearch {
    width: 100%;
    margin-bottom: 20px;
    overflow: hidden;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    .el-input {
      height: 30px;
      margin-right: 10px;
      .el-input__inner {
        height: 30px;
        line-height: 28px;
        border-radius: 0;
      }
      .el-input__icon {
        line-height: 28px;
      }
    }
    .search_input{
      width: 230px;
    }
    
    .serach_title{
      font-size: 12px;
      font-weight: 400;
      color: #4A4A4A;
    }
    // .el-input:nth-child(1) {
    //   width: 180px;
    // }
    // .el-input:nth-child(2) {
    //   width: 193px;
    // }
    .el-select {
      float: left;
      .el-input {
        width: 151px;
      }
    }
    .organization{
       .el-input {
        width: 130px;
      }
    }
    .el-input__inner::placeholder{
      font-size: 12px;
      color: #B9B9B9;
    }
    .search {
      width: 74px;
      height: 30px;
      background: #D81212;
      border-radius: 2px;
      font-size: 13px;
      font-weight: 500;
      color: #FFFFFF;
      float: left;
      text-align: center;
      line-height: 30px;
      // background: url("../../../../assets/images/warning/search_icon_nor.png")
      //   no-repeat;
      cursor: pointer;
      // img {
      //   width: 100%;
      //   height: 100%;
      // }
    }
    .search:hover {
      // background: url("../../../../assets/images/warning/search_icon_pre.png");
    }
  
  }
 
  table {
    width: 100% !important;
    th,
    td {
      vertical-align: middle;
      height: 30px;
      padding: 0;
      text-align: center;
      .cell{
        padding:0;
        text-align: center;
        color: #242C32 !important;
        font-size: 12px;
        height: 100%;

      }
    }
    td{
      .cell{
        color: #242C32 !important;
      }
    }
    // th:nth-child(1),
    // td:nth-child(1) {
    //   width: 18%;
    // }
    // th:nth-child(2),
    // td:nth-child(2) {
    //   width: 13.7%;
    // }
    // th:nth-child(3),
    // td:nth-child(3) {
    //   width: 11.3%;
    // }
    // th:nth-child(4),
    // td:nth-child(4) {
    //   width: 7%;
    // }
    // th:nth-child(5),
    // td:nth-child(5) {
    //   width: 8%;
    // }
    // th:nth-child(6),
    // td:nth-child(6) {
    //   width: 11.7%;
    // }
    // th:nth-child(7),
    // td:nth-child(7) {
    //   width: 6.5%;
    // }
    // th:nth-child(8),
    // td:nth-child(8) {
    //   width: 21.8%;
    // }
    td:nth-child(7):hover {
      cursor: pointer;
      color: #e88078;
    }
    td:nth-child(8) {
     
      // span:hover {
      //   cursor: pointer;
      //   color: #e88078;
      // }
      span{
        color:#0091FF; 
        margin-right: 10px;
        cursor: pointer;
      }
      span:last-child{
        margin:0;
      }
    }
    thead{
      tr{
        th{
          background-color: #f9f9f9;
        }
      }
    }
  }
  .hintMessageBox{
    .hintMessCon{
      display: flex;
      flex-direction: column;
      height: 200px;
    }
    p:nth-child(1){
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    p:nth-child(2){
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          height: 50px;
          span{
            display:block;
            width: 100px;
            height: 30px;
            border: 1px solid #db4437;
            line-height: 30px;
            padding: 0;
            border-radius: 0;
            background-color: #fff;
            font-size: 12px;
            color: #646464;
            text-align: center;
          }
          span:last-child{
                color: #db4437;
                margin-left: 100px;
          }
          span:hover{
            color:#fff;
            border-color:#db4437;
            background-color: #db4437;
          }
    }
  }
    .dataPickerCustom {
    width: 135px;
    height: 30px;
    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
    .el-input--suffix .el-input__inner {
      padding-right: 20px;
    }
    .input__inner {
      padding-right: 0;
    }
    .el-input__icon {
      line-height: 30px;
    }
  }
}
</style>